// extracted by mini-css-extract-plugin
export default {"modal":"ChangeManager_modal__TokIG","user":"ChangeManager_user__0rYDb","image":"ChangeManager_image__wEddI"};